import { render } from "./LoadingBar.vue?vue&type=template&id=e25d9b2e"
import script from "./LoadingBar.vue?vue&type=script&lang=ts"
export * from "./LoadingBar.vue?vue&type=script&lang=ts"
script.render = render

export default script